import React, { Component } from "react";

import FlightServiceAlternative from "./FlightServiceAlternative";
import Cost from "./Cost";
import { List } from "immutable";
import classnames from "classnames";
import scrollToComponent from "react-scroll-to-component";

/* Renders a combined offer - which consist of a series of service alternatives for each requested service grouped by cost and validating service provider.
 */
class CombinedOffer extends Component {
  constructor() {
    super();
    this.state = {
      /*chosen service detail URIs*/
      selectedServiceDetailURIs: undefined
    };
  }

  componentWillMount() {
    const selectedUri = this.props.offer.get("offerURIs").reduce((found, uri) => {
      return this.props.selectedOffers.includes(uri) ? uri : found + "";
    }, "");

    // if (selectedUri!=="") // this offer is currently selected
    const key = this.props.combinedOffersIndex.get(this.props.ogIndex).keyOf(selectedUri); // undefined === offer not selected

    if (key === undefined) {
      this.setState({
        selectedServiceDetailURIs: this.props.offer.get("serviceAlternatives").reduce(
          (selectedURIs, sa) =>
            selectedURIs.push(
              sa
                .get("serviceDetail")
                .first()
                .get("uri")
            ),
          List()
        )
      });
    } else {
      this.setState({
        selectedServiceDetailURIs: this.props.offer.get("serviceAlternatives").reduce(
          (selectedURIs, sa) =>
            selectedURIs.push(
              sa
                .get("serviceDetail")
                .find((v, k) => key.indexOf(k) !== -1)
                .get("uri")
            ),
          List()
        )
      });
    }
  }

  getOfferURIKey(selectedURIs, cost) {
    return cost + selectedURIs.join("");
  }

  updateSelectedURIs = (index, cost) => uri => {
    const newSelecteURIs = this.state.selectedServiceDetailURIs.set(index, uri);
    const offerUri = this.props.combinedOffersIndex.get(this.props.ogIndex).get(this.getOfferURIKey(newSelecteURIs, cost));

    const offerSelected = this.props.offer.get("offerURIs").reduce((found, uri) => this.props.selectedOffers.includes(uri) || found, false);

    this.setState({
      selectedServiceDetailURIs: newSelecteURIs
    });

    if (offerSelected) {
      this.props.selectOffer(offerUri);
      scrollToComponent(this.ref, { offset: 0, align: "top", duration: 500, ease: "inQuad" });
    }
  };

  toggleSelectOffer = (fn, cost) => {
    console.log("clicked");
    
    const offerUri = this.props.combinedOffersIndex.get(this.props.ogIndex).get(this.getOfferURIKey(this.state.selectedServiceDetailURIs, cost));
    fn(offerUri, this.ref);
  };

  render() {
    const { offer, selectOffer, unselectOffer, airportByIata, passengerCount, selectedOffers } = this.props;
    const offerSelected = offer.get("offerURIs").reduce((found, offerURI) => selectedOffers.includes(offerURI) || found, false);

    return (
      <div
        ref={elem => (this.ref = elem)}
        style={{
          display: offer.get("match") ? "block" : "none"
        }}
        className={classnames({
          "result-group": true,
          hoverable: true,
          selected: offerSelected
        })}
      >
        {offer.get("serviceAlternatives").map((sa, index) => (
          <FlightServiceAlternative
            serviceAlternative={sa}
            key={index}
            airportByIata={airportByIata}
            showMoreOptions={offerSelected && this.props.showMoreOptions}
            updateSelectedURIs={this.updateSelectedURIs(index, offer.getIn(["cost", "amount"]))}
            selectedServiceURI={this.state.selectedServiceDetailURIs.get(index)}
          />
        ))}
        <div
          className="col-sm-5 col-lg-4 price-col"
          onClick={() =>
            offerSelected
              ? this.toggleSelectOffer(unselectOffer, offer.getIn(["cost", "amount"]))
              : this.toggleSelectOffer(selectOffer, offer.getIn(["cost", "amount"]))
          }
          style={{
            cursor: "pointer"
          }}
        >
          <Cost cost={offer.get("cost")} passengerCount={passengerCount} selected={offerSelected}></Cost>
        </div>
        <i className={offerSelected ? "tl-corner-selected" : "tl-corner"} />
        <div
          className="col-xs-4 col-sm-2"
          style={{
            textAlign: "center",
            height: "20px",
            fontSize: "0.7em",
            position: "absolute",
            bottom: "0",
            paddingTop: "5px",
            backgroundColor: offer.get("sourceContentProviderName") === "Sabre" ? "#e50000" : "#2e5c99",
            color: "white",
            borderBottomLeftRadius: "4px",
            borderTopRightRadius: "2em"
          }}
        >
          <div className="v-align" style={{ height: "100%", width: "100%", paddingLeft: "5px", paddingRight: "5px" }}>
            {offer.get("sourceContentProviderName")}
          </div>
        </div>
      </div>
    );
  }
}

export default CombinedOffer;



// WEBPACK FOOTER //
// ./src/ndc/offer/CombinedOffer.js